import { Pagination } from "services/search";

import {
  AnnualTax,
  AnnualTaxEditFormValues,
  AnnualTaxRow,
} from "./types";
import {
  transformAnnualTax,
  transformAnnualTaxOnCreate,
  transformAnnualTaxOnUpdate,
  transformAnnualTaxRow,
} from "./transformations";

import { DataWithPagination } from "services/api/types";
import { createApiCall, paginatedApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";

/*---------------------------------------------------------------------------------------
 CALCULATION ANNUAL TAX SEARCH
-----------------------------------------------------------------------------------------*/

export const getAnnualTaxsAPI = async (
  pagination: Pagination,
  name?: string | null
): Promise<DataWithPagination<AnnualTaxRow>> => {
  let path = `/v1/expenses/tax?name=`;

  if (name) path += `${name}`;

  return await paginatedApiCall(
    path,
    pagination,
    transformAnnualTaxRow
  );
};

/*---------------------------------------------------------------------------------------
    CALCULATION - ANNUAL TAX - BY ID
-----------------------------------------------------------------------------------------*/
export const getAnnualTaxAPI = async (
  id: string
): Promise<AnnualTax> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/tax/${id}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformAnnualTax(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION - ANNUAL TAX - CREATE
-----------------------------------------------------------------------------------------*/
export const createAnnualTaxAPI = async (
  formValues: AnnualTaxEditFormValues
): Promise<AnnualTax> => {
  const response = await createApiCall(
    {
      path: "/v1/expenses/tax/",
      method: "POST",
      body: transformAnnualTaxOnCreate(formValues),
    },
    {
      getMessage: {
        success: () => "Godišnji porez je uspješno kreirana",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformAnnualTax(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION - ANNUAL TAX - UPDATE
-----------------------------------------------------------------------------------------*/
export const updateAnnualTaxAPI = async (
  id: string,
  formValues: AnnualTaxEditFormValues
): Promise<AnnualTax> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/tax/${id}`,
      method: "PUT",
      body: transformAnnualTaxOnUpdate(formValues),
    },
    {
      getMessage: {
        success: () => "Godišnji porez je uspješno ažuriran",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformAnnualTax(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION - ANNUAL TAX - DELETE
-----------------------------------------------------------------------------------------*/
export const deleteAnnualTaxAPI = async (
  id: string
): Promise<AnnualTax> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/tax/${id}`,
      method: "DELETE",
    },
    {
      getMessage: {
        success: () => "Godišnji porez je uspješno obrisana",
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformAnnualTax(response.data);
};
